import React, { useState, useEffect } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { toast } from "react-toastify";
import moment from "jalali-moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import { useSetting } from "../../../../context/SettingContext";
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import { fixNumbers } from "../../../../utils";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import AdminOrderCard from "../../shares/AdminOrderCard";

const CreateAccorionHeader = ({ bangle, totals, id, handle_select_bangle }) => {
  const { showNumSix, reverseShowNums } = useSetting();
  return (
    <div
      className="grid grid-cols-8 w-full bg-slate-100 p-4 rounded-lg my-4 cursor-pointer transition-all hover:bg-slate-200"
      onClick={() => handle_select_bangle(id)}
    >
      <div className="col-span-2">
        <span className="text-myblue-100">{bangle.show_name}</span>/
        <span className="text-myblue-100">{bangle.brand_name}</span>/
        <span className="bg-slate-100 rounded-lg p-1">
          {bangle.gender == "girl" ? "بچه گانه" : "زنانه"}
        </span>
        /
        {bangle.color == "yellow" ? (
          <span className="bg-yellow-400 rounded-lg p-1">زرد</span>
        ) : (
          <span className="bg-slate-50 border border-slate-200 rounded-lg p-1">
            سفید
          </span>
        )}{" "}
      </div>
      {reverseShowNums ? (
        <>
          {showNumSix ? <span>ج۶: {totals.size_six_num}</span> : ""}
          <span>ج۵: {totals.size_five_num}</span>
          <span>ج۴: {totals.size_four_num}</span>
          <span>ج۳: {totals.size_three_num}</span>
          <span>ج۲: {totals.size_two_num}</span>
          <span>ج۱: {totals.size_one_num}</span>
        </>
      ) : (
        <>
          <span>ج۱: {totals.size_one_num}</span>
          <span>ج۲: {totals.size_two_num}</span>
          <span>ج۳: {totals.size_three_num}</span>
          <span>ج۴: {totals.size_four_num}</span>
          <span>ج۵: {totals.size_five_num}</span>
          {showNumSix ? <span>ج۶: {totals.size_six_num}</span> : ""}
        </>
      )}
    </div>
  );
};

const AggregatedRemainCustomer = (props) => {
  const { userData } = useUserData();
  const { defaultRingSize } = useSetting();
  let windowWidth = window.screen.width;
  const [selectedBangle, setSelectedBangle] = useState();
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined) {
        getAggregateBangles.reFetch();
      }
  }, [openModal]);

  const [aggregatedBangles, setAggregatedBangles] = useState([]);

  const getAggregateBangles = useFetch({
    method: "get",
    url: `User_Service/${props.selectedRow.username}/admin_get_report_customer_order_items_bangles`,
    trigger: false,
    setter: setAggregatedBangles,
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [currentOerdersDetail, setCurrentOerdersDetail] = useState([]);
  const [initialValues, setInitialValues] = useState({});

  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };
  const [showDetail, setShowDetail] = useState(false);
  const getOrderDetailsApi = useFetch({
    method: "post",
    url: `User_Service/${props.selectedRow.username}/admin_get_report_customer_order_items_using_iss_bangle`,
    trigger: false,
    data: {
      bangle: selectedBangle,
    },
    setter: setCurrentOerdersDetail,
    // params: { admin_change_item: statusFilter },
    argFunc: (res) => {
      setShowDetail(true);

      let tmp = {};
      res.map((item, ind) => {
        if (item.admin_change_item) {
          tmp[item.id] = [];
          tmp[item.id].push(
            item.size_one_num - item.admin_size_one_num > 0
              ? item.size_one_num - item.admin_size_one_num
              : 0
          );
          tmp[item.id].push(
            item.size_two_num - item.admin_size_two_num > 0
              ? item.size_two_num - item.admin_size_two_num
              : 0
          );
          tmp[item.id].push(
            item.size_three_num - item.admin_size_three_num > 0
              ? item.size_three_num - item.admin_size_three_num
              : 0
          );
          tmp[item.id].push(
            item.size_four_num - item.admin_size_four_num > 0
              ? item.size_four_num - item.admin_size_four_num
              : 0
          );
          tmp[item.id].push(
            item.size_five_num - item.admin_size_five_num > 0
              ? item.size_five_num - item.admin_size_five_num
              : 0
          );
          tmp[item.id].push(
            item.size_six_num - item.admin_size_six_num > 0
              ? item.size_six_num - item.admin_size_six_num
              : 0
          );
        } else {
          console.log('object123123123')
          tmp[item.id] = [];
          tmp[item.id].push(item.admin_size_one_num);
          tmp[item.id].push(item.admin_size_two_num);
          tmp[item.id].push(item.admin_size_three_num);
          tmp[item.id].push(item.admin_size_four_num);
          tmp[item.id].push(item.admin_size_five_num);
          tmp[item.id].push(item.admin_size_six_num);
        }
      });

      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      // toast.error("خطایی رخ داده است", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
  });

  const handle_select_bangle = (id) => {
    setSelectedBangle(id);
    getOrderDetailsApi.reFetch();
  };

  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const updateDetailsApi = useFetch({
    method: "patch",
    url: `OrderItem_Service/${selectedItem}/update_order_item_with_remains`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setCurrentOerdersDetail([]);
      getOrderDetailsApi.reFetch();
      // props.adminGetCustomerCurrentOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const resetUpdateDetailsApi = useFetch({
    method: "get",
    url: `OrderItem_Service/${selectedItem}/reset_update_order_item`,
    trigger: false,
    // data: patchData,

    argFunc: (res) => {
      setCurrentOerdersDetail([]);
      // props.adminGetCustomerCurrentOrderApi.reFetch();

      getOrderDetailsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [childrenItemDate, setChildrenItemDate] = useState();

  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      admin_size_one_num:
        initialValues[ringItemId][0] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][0]))
          : 0,
      admin_size_two_num:
        initialValues[ringItemId][1] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][1]))
          : 0,
      admin_size_three_num:
        initialValues[ringItemId][2] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][2]))
          : 0,
      admin_size_four_num:
        initialValues[ringItemId][3] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][3]))
          : 0,
      admin_size_five_num:
        initialValues[ringItemId][4] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][4]))
          : 0,
      admin_size_six_num:
        initialValues[ringItemId][5] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][5]))
          : 0,
      receive_at: moment(childrenItemDate).format("YYYY-MM-DD"),
      admin_change_item: true,
    });
    updateDetailsApi.reFetch();
  };

  const reset_update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);

    resetUpdateDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  const [expanded, setExpanded] = useState(undefined);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : undefined);
  };

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<VisibilityIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
        NeedCloseState={setShowDetail}
        NeedClose
      >
        <div>
          {!showDetail && (
            <div className="max-h-[32rem] overflow-scroll">
              {aggregatedBangles.map((item, index) => {
                return (
                  <CreateAccorionHeader
                    bangle={item}
                    totals={item.total_bangle_nums}
                    id={item.id}
                    handle_select_bangle={handle_select_bangle}
                  />
                );
              })}
            </div>
          )}

          {showDetail && (
            <>
              <div className="flex justify-end">
                <div
                  className=" my-2 inline-flex justify-end items-center text-gray-500 text-sm transition-all hover:text-black cursor-pointer"
                  onClick={() => {
                    setShowDetail(false);
                    getAggregateBangles.reFetch();
                  }}
                >
                  <span>بازگشت</span>
                  <ArrowBackIcon />
                </div>
              </div>
              <div className="max-h-[32rem] overflow-scroll">
                {currentOerdersDetail.map((item, index) => {
                  return [
                    <div className="grid grid-cols-12 items-center">
                      <span className="">سند: {item.unique_id}</span>
                      <div className=" col-span-11">
                        <AdminOrderCard
                          update_ring_item={update_ring_item}
                          reset_update_ring_item={reset_update_ring_item}
                          // showResetAcceptBtn
                          DontShowDatePicker
                          showAcceptBtn
                          DontshowEditIconForAdmin
                          item={item}
                          move_date_to_parent={move_date_to_parent}
                          showRemainTotal
                          // adminNeedDifference
                        >
                          <OrderCardLeftPartTemplate
                            adminNeedRemainUSerValues
                            nums={nums}
                            update_nums={update_nums}
                            dynamicMap={true}
                            data_item={item}
                            ringId={item.id}
                            adminDidntNeedCustomerRequestNum
                            // adminNeedColor
                          />
                        </AdminOrderCard>
                      </div>
                    </div>,
                  ];
                })}
              </div>
            </>
          )}
        </div>
      </TableIconModal>
    </>
  );
};

export default AggregatedRemainCustomer;
